const publicURL = "/assets/pdf/";

const getPdf = (name) => `${publicURL}${name}.pdf`;

export const PRIVACY_POLICY_PDF = getPdf("privacy-policy-2025");
export const TOU_PDF = getPdf("terms-of-use-2025");
